import React from "react";
import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { validateExpirationDate } from "../../utils/handlePremiereDates";
import { BASE_PATH } from '../../constants/awsBaseUrl';

const PremierePlaylistVideo = ({ id, index, filename,item, description, onClick }) => {
  const {companyEndpoint} = useContext(GlobalContext);
  let customThumbnail=`${BASE_PATH}/outputs/${id}/Default/Thumbnails/out_003.png`
  let fallback =`${BASE_PATH}/outputs/${id}/Default/Thumbnails/out_003.png?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}`
  return (
    <div className="plst-item">
      
      <div className="plst-item-number">{index}</div>
      
      <div className="plst-item-thumb">
      <div className="thumbnail">
      <a href={`https://cloud.castus.tv/vod/${companyEndpoint}/video/${id}`} onClick={e=>{
        if (validateExpirationDate(item?.premiereDate)) {
          e.preventDefault()
        }
      }} style={{ textDecoration: 'none' }}>
        <img
          src={customThumbnail}
          onError={e=>e.target.src=fallback}
          style={{
            width:'100%', 
            filter: validateExpirationDate(item?.premiereDate) && 'brightness(0.3)'
          }}
           
        />
        </a>
        </div>
      </div>
      <div className="plst-item-body">
        <p className="plst-item-title">{filename}</p>
        <p>{description}</p>
      </div>
      
    </div>
  );
};
export default PremierePlaylistVideo;
